import { PauseCircleFilledRounded, PlayCircleRounded } from "@mui/icons-material";
import { Stack } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useRef, useState } from "react";

export function AudioPlayer({ src }: { src: string }) {
    const audioRef = useRef<HTMLAudioElement>(null);
    const [playing, setPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);

    const togglePlay = () => {
        const audio = audioRef.current;
        if (!audio) return;
        if (playing) {
            audio.pause();
        } else {
            audio.play();
        }
        setPlaying(!playing);
    };

    const formatTime = (seconds: number) => {
        const formattedMinutes = Math.floor(seconds / 60);
        const formattedSeconds = String(Math.floor(seconds % 60)).padStart(2, "0");
        return `${formattedMinutes}:${formattedSeconds}`;
    };

    return (
        <Stack alignItems="center" padding={0.5}>
            {/** biome-ignore lint/a11y/useMediaCaption: <bat noises are difficult to caption> */}
            <audio
                ref={audioRef}
                src={src}
                onTimeUpdate={e => setCurrentTime(e.currentTarget.currentTime)}
                onLoadedMetadata={e => setDuration(e.currentTarget.duration)}
                onEnded={() => setPlaying(false)}
            />
            <IconButton onClick={togglePlay}>
                {playing ? <PauseCircleFilledRounded fontSize="large" /> : <PlayCircleRounded fontSize="large" />}
            </IconButton>
            <Typography variant="caption">
                {formatTime(currentTime)} / {formatTime(duration)}
            </Typography>
        </Stack>
    );
}
